/* TAYRO — category slider rows: arrows, swipe, and shop filters */
(function () {
  'use strict';

  function setupRow(row) {
    if (row.__srow) return;
    row.__srow = true;
    var track = row.querySelector('[data-srow-track]');
    var prev = row.querySelector('[data-srow-dir="-1"]');
    var next = row.querySelector('[data-srow-dir="1"]');
    if (!track) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      row.classList.toggle('no-scroll', max <= 4);
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max - 4;
    }
    function go(dir) {
      var card = track.querySelector('.card');
      var stepW = card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
      var per = Math.max(1, Math.floor((track.clientWidth + 24) / stepW));
      track.scrollBy({ left: dir * per * stepW, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', update, { passive: true });
    row.__update = update;
    update();
  }

  function updateAll() {
    document.querySelectorAll('[data-srow]').forEach(function (r) {
      setupRow(r);
      if (r.__update) r.__update();
    });
  }
  window.tayroRowsUpdate = updateAll;

  updateAll();
  window.addEventListener('load', updateAll);
  window.addEventListener('resize', updateAll);
  // Homepage tabs (radio inputs) reveal hidden rows: re-measure them
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'ctab') setTimeout(updateAll, 0);
  });

  /* Shop page: Shop all / Apparel / Golf Gear + category chips */
  var shop = document.getElementById('shop-groups');
  if (!shop) return;
  var rows = shop.querySelectorAll('[data-srow]');
  // Build the category chips from the rows that actually have products
  var chipBox = shop.querySelector('[data-cat-chips]');
  if (chipBox) {
    var html = '<button type="button" role="tab" data-group-tab="all">All</button>';
    rows.forEach(function (r) {
      html += '<button type="button" role="tab" data-group-tab="' + r.getAttribute('data-group') + '" data-super="' + r.getAttribute('data-super') + '">' + r.getAttribute('data-label') + '</button>';
    });
    chipBox.innerHTML = html;
    if (rows.length < 2) chipBox.style.display = 'none';
  }
  var superBox = shop.querySelector('.super-tabs');
  var hasA = shop.querySelector('[data-srow][data-super="apparel"]');
  var hasG = shop.querySelector('[data-srow][data-super="gear"]');
  if (superBox && !(hasA && hasG)) superBox.style.display = 'none';
  var supers = shop.querySelectorAll('[data-super-tab]');
  var chips = shop.querySelectorAll('[data-group-tab]');
  var countEl = shop.querySelector('[data-shop-count]');
  var current = 'all';
  var picked = 'all';

  function inSuper(el) { return current === 'all' || el.getAttribute('data-super') === current; }

  function render(push) {
    var total = 0, shownRows = 0, label = '';
    supers.forEach(function (b) {
      var on = b.getAttribute('data-super-tab') === current;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    chips.forEach(function (b) {
      var t = b.getAttribute('data-group-tab');
      b.hidden = t !== 'all' && !inSuper(b);
      var on = t === picked;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    rows.forEach(function (r) {
      var on = inSuper(r) && (picked === 'all' || r.getAttribute('data-group') === picked);
      r.hidden = !on;
      r.classList.toggle('is-solo', on && picked !== 'all');
      if (on) { total += Number(r.getAttribute('data-count')) || 0; shownRows++; label = r.getAttribute('data-label'); }
    });
    if (countEl) {
      var what = picked !== 'all' ? label : (current === 'gear' ? 'golf gear' : current === 'apparel' ? 'apparel' : 'products');
      countEl.textContent = 'Showing ' + total + ' ' + (picked !== 'all' ? (total === 1 ? 'piece' : 'pieces') + ' in ' + what : (total === 1 ? 'piece' : 'pieces') + (what === 'products' ? '' : ' of ' + what));
    }
    if (push) {
      try {
        var u = new URL(location.href);
        var cat = picked !== 'all' ? picked : (current !== 'all' ? current : '');
        if (cat) u.searchParams.set('cat', cat); else u.searchParams.delete('cat');
        history.replaceState(null, '', u.toString());
      } catch (e) {}
    }
    updateAll();
  }

  supers.forEach(function (b) {
    b.addEventListener('click', function () { current = b.getAttribute('data-super-tab'); picked = 'all'; render(true); });
  });
  chips.forEach(function (b) {
    b.addEventListener('click', function () {
      picked = b.getAttribute('data-group-tab');
      if (picked !== 'all' && current !== 'all' && b.getAttribute('data-super') !== current) current = b.getAttribute('data-super');
      render(true);
    });
  });

  // Deep links: ?cat=apparel | gear | golf | hoodie | towel ...
  var cat = new URLSearchParams(location.search).get('cat');
  if (location.hash === '#golf') cat = 'gear';
  if (cat === 'golf') cat = 'gear';
  if (cat === 'apparel' || cat === 'gear') { current = cat; }
  else if (cat && shop.querySelector('[data-srow][data-group="' + cat + '"]')) { picked = cat; }
  render(false);
})();
